import * as t from "io-ts";

export const PostTypeV = t.type({ name: t.string, slug: t.string });
export const PostTypesV = t.array(t.type({ name: t.string, slug: t.string }));

export type PostType = t.TypeOf<typeof PostTypeV>;
